import { LOGO_ACCEPTED_TYPES, LOGO_MAX_SIZE_BYTES } from './constants';

export const validateFileSync = (file: File): string | null => {
    if (!LOGO_ACCEPTED_TYPES.includes(file.type)) {
        return 'Invalid file type. Accepted formats: .png, .jpg, .svg.';
    }
    if (file.size > LOGO_MAX_SIZE_BYTES) {
        return 'File size exceeds 5 MB limit.';
    }
    return null;
};

export const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const getImageDimensions = (file: File): Promise<{ width: number; height: number }> => {
    return new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            resolve({ width: img.naturalWidth, height: img.naturalHeight });
            URL.revokeObjectURL(url);
        };
        img.onerror = () => {
            resolve({ width: 0, height: 0 });
            URL.revokeObjectURL(url);
        };
        img.src = url;
    });
};
